module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/KnightFight.c98bb73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/KnightFight.jpg
// module id = FPqC
// module chunks = 0